import { ArticleParagraph2 } from '@cian/ui-kit';
import { IconPlaceholderImages24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './CarouselNoMedia.css';

export const CarouselNoMedia: React.FC = () => {
  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        <IconPlaceholderImages24 color="icon-secondary-default" width={40} height={40} />
        <ArticleParagraph2 color="text-primary-default">Фотографии отсутствуют</ArticleParagraph2>
      </div>
    </div>
  );
};
